import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { getClientId } from "@/lib/clientId";
import { useAuth } from "@/lib/AuthContext";

const CreditsCtx = createContext({
  balance: 0,
  lifetimePurchased: 0,
  refresh: () => {},
});

export function CreditsProvider({ children }) {
  const [balance, setBalance] = useState(0);
  const [lifetimePurchased, setLifetimePurchased] = useState(0);
  const { user } = useAuth();

  const refresh = useCallback(async () => {
    try {
      const key = user?.id || getClientId();
      const { data } = await api.get(`/credits?client_id=${encodeURIComponent(key)}`);
      setBalance(data.balance || 0);
      setLifetimePurchased(data.lifetime_purchased || 0);
    } catch (_e) {
      // silent
    }
  }, [user]);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 20000);
    return () => clearInterval(t);
  }, [refresh]);

  // also refresh after any non-GET api call finishes (that's when credits change)
  useEffect(() => {
    const id = api.interceptors.response.use((res) => {
      const m = res.config?.method || "";
      if (m && m.toLowerCase() !== "get") setTimeout(refresh, 400);
      return res;
    });
    return () => api.interceptors.response.eject(id);
  }, [refresh]);

  return (
    <CreditsCtx.Provider value={{ balance, lifetimePurchased, refresh }}>
      {children}
    </CreditsCtx.Provider>
  );
}

export function useCredits() {
  return useContext(CreditsCtx);
}
